import React, { useState } from 'react';
import { Form, FormControl, Row, Col, Button, Card } from 'react-bootstrap';
import './component.css';
import { useIntl } from 'react-intl';

export const EncounterLoginComponent = ({ login }) => {
    const [code, setCode] = useState("");

    const intl = useIntl();

    function submitLogin(event) {
        event.preventDefault();
        login(code);
        setCode("");
    }

    return (
        <Form onSubmit={submitLogin}>
            <Row className="align-items-center justify-content-center">
                <Col lg={10}>
                    <Row >
                        <Col>
                            <Card className="border-0">
                                <Card.Title style={{ marginBottom: "2.5%", fontSize: '100%', fontWeight:'bold', marginTop:"3%" }}>
                                    {intl.formatMessage({id: 'monitoraggioPazientePage.labelAggiungiPazienti'})}
                                </Card.Title>
                            </Card>
                        </Col>
                    </Row>
                </Col>
                <Col lg={10}>
                    <Row >
                        <Col lg={8}>
                            <Card className="border-0 border-card my-3 mt-md-0">
                                <FormControl
                                    className="container-fluid px-4 py-3 py-md-2 h-auto"
                                    style={{ borderRadius: "8pt"}}
                                    type="string"
                                    value={code}
                                    onChange={(event) => setCode(event.target.value.trim()) }
                                    placeholder={intl.formatMessage({ id: 'monitoraggioPazientePage.placeholderInputAggiungiPazienti'})} />
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card className="border-0 border-card d-block">
                                <Button
                                    type="submit"
                                    className="container-fluid px-4 py-3 py-md-2"
                                    variant={"danger"}
                                    style={{ display: 'inherit', textTransform: 'uppercase', borderRadius: "8pt" }}
                                    disabled={code.length === 0}
                                >
                                    <b>{intl.formatMessage({id: 'monitoraggioPazientePage.labelBottoneAggiungiPazienti'})}</b>
                                </Button>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Form>
    );
}
